/**
 * Use this in the default case of a switch statement for enum exhaustion compile-time assertion.
 */
export function assertUnreachable(type: never): never {
  throw new Error(`Didn't expect to get here: ${JSON.stringify(type as any).slice(0, 100)}`)
}
